import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-bookings__spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "my-bookings__header"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col--4 d--none d-md--block" }
const _hoisted_5 = { class: "col--4 d--none d-md--block" }
const _hoisted_6 = { class: "my-bookings__list" }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountSearchBookings = _resolveComponent("AccountSearchBookings")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_MyBookingItem = _resolveComponent("MyBookingItem")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, { class: "my-bookings" }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("account.bookings.subtitle")), 1)
    ]),
    default: _withCtx(() => [
      (_ctx.isAgent)
        ? (_openBlock(), _createBlock(_component_AccountSearchBookings, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_BaseSpinner, { size: 50 })
            ]))
          : _createCommentVNode("", true),
        (_ctx.fetched)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col--2 d--none d-md--block" }, [
                  _createElementVNode("h4")
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("departure.outward")), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t("departure.return")), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_6, [
          (_ctx.bookingsList.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.bookingsList, (booking, index) => {
                return (_openBlock(), _createBlock(_component_MyBookingItem, {
                  key: index,
                  booking: booking,
                  isAgent: _ctx.isAgent
                }, null, 8, ["booking", "isAgent"]))
              }), 128))
            : (_ctx.fetched)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createVNode(_component_BaseAlert, {
                    type: "info",
                    message: _ctx.$t('messages.myAccount.bookings.empty')
                  }, null, 8, ["message"])
                ]))
              : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}